import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PublicFaqSection from "@/components/PublicFaqSection";
import { Button } from "@/components/ui/button";

const JotformBackupSoftwarePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow">
        <section className="py-16 md:py-24 border-b">
          <div className="container mx-auto px-6 max-w-4xl">
            <p className="text-sm font-semibold text-primary mb-3">SaaS form backup</p>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">
              Backup software for teams that depend on Jotform
            </h1>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              FAB is a web-based backup service for Jotform form metadata. It gives teams a
              separate backup system for form structure, settings, fields, webhooks, and restore
              history when the form itself is business-critical.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild size="lg">
                <Link to="/features">See Features</Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/pricing">Compare Plans</Link>
              </Button>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20">
          <div className="container mx-auto px-6 max-w-4xl prose prose-gray dark:prose-invert">
            <h2>What makes FAB different from manual exports?</h2>
            <p>
              Manual exports depend on someone remembering to export the right form at the right
              time. FAB is built as a recurring backup lane: daily automated backups, manual backup
              controls for major changes, backup history, and restore workflows all live in one
              place.
            </p>
            <h2>What kind of SaaS product is FAB?</h2>
            <p>
              FAB is backup and recovery software for online form configuration. It is most useful
              when Jotform forms represent operational workflows, intake processes, customer-facing
              forms, or internal processes that would be expensive to rebuild by hand.
            </p>
            <h2>What FAB does not claim to do</h2>
            <p>
              FAB does not replace Jotform, does not store respondent submission content, and does
              not claim affiliation with Jotform. Its public purpose is narrower: independent backup
              and restore coverage for Jotform form structure.
            </p>
          </div>
        </section>

        <PublicFaqSection />
      </main>
      <Footer />
    </div>
  );
};

export default JotformBackupSoftwarePage;
